'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _applyBind = require('./applyBind');

var _applyBind2 = _interopRequireDefault(_applyBind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * debounce
 * @param {Function} fn 需要延迟调用的函数
 * @param {Number=0} idle 空闲时间，单位毫秒
 * @param {Boolean=false} immediate
 * true：表示首次调用返回值方法时，会马上调用fn
 * @param {Function=null} fnStill 延迟期间仍会调用的函数 默认为空
 */
function debounce(fn, idle, immediate, fnStill) {
  var options = {
    fn: fn,
    idle: idle,
    immediate: immediate,
    fnStill: fnStill,
    context: undefined,
    arguments: undefined,
    timer: undefined
  };
  return function () {
    options.fnStill && options.fnStill();
    options.context = this;
    options.arguments = arguments;
    if (options.timer) {
      clearTimeout(options.timer);
    } else {
      if (options.immediate) {
        options.fn.apply(options.context, options.arguments);
        options.context = options.arguments = null;
      }
    }
    options.timer = setTimeout((0, _applyBind2.default)(later, options), options.idle);
  };
} /**
   * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 idle（ms），fn 才会执行
   */

function later() {
  this.timer = null;
  this.fn.apply(this.context, this.arguments);
  if (this.context && this.arguments) {
    this.context = this.arguments = null;
  }
}

exports.default = debounce;


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/debounce.js
// module id = 170
// module chunks = 0